import { Directive, booleanAttribute, input } from '@angular/core';

/**
 * Loading Button Directive
 *
 * Replacement for PrimeNG's deprecated `[loading]` input on `pButton`. While `nbxLoading` is
 * truthy the host gets a `.nbx-btn-loading` class (styled in the theme): its content is hidden,
 * a spinner overlays it in the button's own colour, and pointer events are blocked. `aria-busy`
 * is reflected for assistive tech. Compose with the consumer's own `[disabled]` as needed.
 *
 * @example
 * <button pButton nbxLoading [nbxLoading]="saving()">…</button>
 */
@Directive({
  selector: '[pButton][nbxLoading], p-button[nbxLoading]',
  standalone: true,
  host: {
    '[class.nbx-btn-loading]': 'nbxLoading()',
    '[attr.aria-busy]': 'nbxLoading() || null',
  },
})
export class ButtonLoadingDirective {
  readonly nbxLoading = input(false, { transform: booleanAttribute });
}
